import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import { ObservationBundle } from '../../../../../types/FHIRTypes/Bundle'
import FhirLoader from '../../../../FhirLoader'
import { isObservationBundle } from '../../../../../typeGuards/fhirTypes'
import { ObservationTable } from '@teschglobal/tg-fhir-react-components'

type ObservationListProps = {
  observationData: ObservationBundle;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const ObservationList: FC<ObservationListProps> = ({ observationData, isFetching, handleChangePage, totalPages, currentPage }) => {
  if (!isObservationBundle(observationData)) return null

  const observations = observationData && observationData.entry ? observationData.entry.map((entry) => entry.resource) : []

  if (isFetching) {
    return <FhirLoader message="Loading..." />
  }

  return (
    <>
      {
        observationData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <span role="status" aria-live="polite">{observationData?.total.toLocaleString()} record(s) found</span>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
      <ObservationTable
        observations={observations}
      />
      {
        observationData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
    </>
  )
}

export default ObservationList